import apiClient from "../api/apiClient";

// const DASHBOARD_API_URL = "https://cbzmjhrz5q.us-east-2.awsapprunner.com";
const DASHBOARD_API_URL = "https://dashboard-api.socialpawsapp.com";

export const EVENTS_URL = `${DASHBOARD_API_URL}/booking/checkJoined`;

const webUrl = (value) => {
  try {
    const url = new URL(value);
    return ["https:", "http:"].includes(url.protocol) ? url.href : "";
  } catch {
    return "";
  }
};

export const normalizeEvent = (event) => {
  const date = new Date(event.event_date);
  const dateLabel = event.event_date && !Number.isNaN(date.getTime())
    ? date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })
    : "Date to be announced";
  const time = typeof event.event_time === "string" && !/nan/i.test(event.event_time)
    ? event.event_time.trim() : "";
  const price = String(event.event_price ?? "").trim();
  return {
    id: String(event._id),
    joined: event.joined === true,
    bookingId: Array.isArray(event.bookings)
      ? event.bookings.map((booking) => typeof booking === "string" ? booking : booking?._id || booking?.id).find(Boolean) || null
      : null,
    title: event.event_name || "Community event",
    date: [dateLabel, time].filter(Boolean).join(", "),
    description: event.event_description || "",
    image: webUrl(event.image),
    registrationUrl: webUrl(event.registration_url),
    price: /\d/.test(price) ? price : "",
  };
};

export const getAllEvents = async ({ signal, email } = {}) => {
  if (typeof email !== "string" || !email.trim()) {
    throw new Error("Your profile email is required to load events and booking status.");
  }
  const response = await apiClient.get(EVENTS_URL, { signal, timeout: 20000, params: { email: email.trim() } });
  if (response.data?.success !== true || !Array.isArray(response.data.data)) {
    throw new Error(response.data?.message || "Unable to load events.");
  }
  const eventTime = (event) => {
    const timestamp = Date.parse(event.event_date);
    return Number.isFinite(timestamp) ? timestamp : -Infinity;
  };
  return response.data.data
    .filter((event) => event && event._id != null)
    .sort((a, b) => eventTime(b) - eventTime(a))
    .map(normalizeEvent);
};

export const BOOK_EVENT_URL = `${DASHBOARD_API_URL}/booking/add`;

export const bookEvent = async (eventId, profile) => {
  if (!eventId || !profile?.id) throw new Error("Please sign in before joining an event.");
  const payload = {
    name: profile.user_name || "",
    email: profile.user_email || "",
    phone_number: String(profile.user_phone ?? "").trim() || "0000000000",
    event: eventId,
  };
  if (!payload.name.trim() || !payload.email.trim()) {
    throw new Error("Please add your name and email to your profile before joining.");
  }
  try {
    const response = await apiClient.post(BOOK_EVENT_URL, payload, { timeout: 20000 });
    if (response.data?.success === false || response.data?.status === false) {
      throw new Error(response.data.message || "Unable to join this event.");
    }
    return response.data;
  } catch (error) {
    if (!error.response && error.isAxiosError) {
      throw new Error("Booking could not be confirmed. Check your bookings before trying again.");
    }
    throw new Error(error.response?.data?.message || error.message || "Unable to join this event.");
  }
};

export const unjoinEvent = async (bookingId) => {
  if (!bookingId || !String(bookingId).trim()) throw new Error("Booking ID is missing. Refresh events and try again.");
  try {
    const response = await apiClient.delete(
      `${DASHBOARD_API_URL}/booking/deleteById/${encodeURIComponent(bookingId)}`,
      { timeout: 20000 },
    );
    if (response.data?.success === false || response.data?.status === false) {
      throw new Error(response.data.message || "Unable to leave this event.");
    }
    return response.data;
  } catch (error) {
    if (!error.response && error.isAxiosError) {
      throw new Error("Cancellation could not be confirmed. Refresh events before trying again.");
    }
    throw new Error(error.response?.data?.message || error.message || "Unable to leave this event.");
  }
};
